import React from "react";
import ReactEChartsCore from "echarts-for-react/lib/core";
import * as echarts from "echarts/core";
import { getColor } from "helpers/utils";
import { tooltipFormatter } from "helpers/echart-utils";

function Graph({ data }) {
  const hours = [
    "10AM",
    "11AM",
    "12AM",
    "01PM",
    "02PM",
    "03PM",
    "04PM",
    "05PM",
    "06PM",
    "07PM",
    "08PM",
  ];

  const colors = [
    "#6F9BF3",
    "#5BD0A2",
    "#5E7090",
    "#F0B91B",
    "#6F5EF9",
    "#6DC8EC",
    "#945FB9",
    "#FF9845",
    "#1E9493",
    "#FF99C3",
    "#5B8FF9",
    "#5AD8A6",
    "#5D7092",
  ];

  const getOption = () => ({
    tooltip: {
      trigger: "axis",
      padding: [7, 10],
      backgroundColor: getColor("gray-100"),
      borderColor: getColor("gray-300"),
      textStyle: getColor("dark"),
      borderWidth: 1,
      formatter: tooltipFormatter,
      transitionDuration: 0,
      axisPointer: {
        type: "none",
      },
    },
    xAxis: {
      type: "category",
      data: hours,
      boundaryGap: false,
      axisLine: {
        lineStyle: {
          color: getColor("gray-300"),
        },
      },
      axisTick: { show: false },
      axisLabel: {
        color: getColor("gray-400"),
        formatter: (value) => value.substring(0, 5),
        margin: 15,
      },
      splitLine: {
        show: false,
      },
    },
    yAxis: {
      type: "value",
      splitLine: {
        lineStyle: {
          type: "dashed",
          color: getColor("gray-200"),
        },
      },
      boundaryGap: false,
      axisLabel: {
        show: true,
        color: getColor("gray-400"),
        margin: 10,
      },
      axisTick: { show: false },
      axisLine: { show: false },
    },
    series: Object.entries(data).map(([name, data], index) => {
      return {
        name,
        type: "line",
        symbolSize: 5,
        itemStyle: {
          color: colors[index],
          borderColor: colors[index],
          borderWidth: 2,
        },
        lineStyle: {
          color: colors[index],
          type: "dashed",
        },
        symbol: "circle",
        stack: "product",
        data: data.slice(9, 20),
      };
    }),

    grid: { right: 10, left: 5, bottom: 0, top: 10, containLabel: true },
  });

  return (
    <div>
      <ReactEChartsCore
        echarts={echarts}
        option={getOption()}
        style={{ height: "18.75rem" }}
        key={new Date()}
      />
    </div>
  );
}

export default Graph;
